function isLocalHostname(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1"
}

function toUrl(frontUrl: string): URL | null {
  const trimmedFrontUrl = frontUrl.trim()

  if (!trimmedFrontUrl) {
    return null
  }

  const hasProtocol = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//.test(trimmedFrontUrl)
  const candidateUrl = hasProtocol
    ? trimmedFrontUrl
    : `${trimmedFrontUrl.includes("localhost") || trimmedFrontUrl.includes("127.0.0.1") ? "http" : "https"}://${trimmedFrontUrl}`

  try {
    return new URL(candidateUrl)
  } catch {
    return null
  }
}

export function resolveFrontOrigin(frontUrl: string | undefined | null, fallbackOrigin?: string): string {
  const parsedUrl = frontUrl ? toUrl(frontUrl) : null

  if (parsedUrl) {
    return parsedUrl.origin
  }

  return fallbackOrigin ?? ""
}

export function buildFrontUrl(pathname: string, options?: { frontUrl?: string | null; fallbackOrigin?: string }): string {
  const normalizedPathname = pathname.startsWith("/") ? pathname : `/${pathname}`
  const origin = resolveFrontOrigin(options?.frontUrl, options?.fallbackOrigin)

  if (!origin) {
    return normalizedPathname
  }

  return `${origin}${normalizedPathname}`
}

export function shouldUseSecureCookies(origin: string | undefined | null): boolean {
  if (!origin) {
    return true
  }

  try {
    const parsedUrl = new URL(origin)
    return parsedUrl.protocol === "https:" || !isLocalHostname(parsedUrl.hostname)
  } catch {
    return true
  }
}
